var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetVisionPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 106 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.2484 7.056C81.4397 4.214 70.8998 3.001 53.0043 3C53 3.001 52.9989 3.001 52.9946 3C35.1002 3.001 24.5604 4.214 17.7517 7.056C17.6869 7.083 17.6287 7.111 17.5651 7.139H14.8629C13.5178 7.139 12.424 8.153 12.424 9.4C12.424 9.543 12.4726 9.672 12.5459 9.786C2.87437 16.112 2.96498 24.866 3.00597 28.462L3.01029 29C3.01029 39.052 8.96897 55 24.9595 55C35.2297 55 40.2974 51.4 44.3694 48.509C47.2646 46.452 49.5515 44.827 53 44.826C56.4475 44.827 58.7354 46.452 61.6306 48.509C65.7027 51.4 70.7704 55 81.0406 55C97.0311 55 102.99 39.052 102.99 29L102.994 28.462C103.04 24.311 103.165 13.284 88.2484 7.056ZM100.555 28.439L100.551 29C100.551 38.178 95.2545 52.739 81.0406 52.739C71.5977 52.739 67.0899 49.538 63.1138 46.714C60.1118 44.582 57.2781 42.569 53.0043 42.565C52.9989 42.565 52.9979 42.565 52.9946 42.565C48.7219 42.568 45.8871 44.582 42.8862 46.714C38.9091 49.538 34.4034 52.739 24.9595 52.739C10.7456 52.739 5.44813 38.178 5.44813 29L5.44381 28.439C5.40174 24.692 5.28956 14.739 18.7527 9.118C25.227 6.415 35.4702 5.262 53 5.261C70.5298 5.262 80.7731 6.415 87.2474 9.118C100.709 14.738 100.597 24.692 100.555 28.439Z",
    fill: "#2E2B63",
    stroke: "#2E2B63",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetVisionPro);
export default __webpack_public_path__ + "static/media/getVisionPro.117fd241a9a5f8b1aba446f44416431f.svg";
export { ForwardRef as ReactComponent };